var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivityClock = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.417 0H5.833a.583.583 0 0 0-.583.583v4.124a4.665 4.665 0 1 0 3.74 6.376h4.427A.583.583 0 0 0 14 10.5V.583A.583.583 0 0 0 13.417 0ZM8.75 1.167h1.75v1.166H8.75V1.167ZM4.667 12.833a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm8.166-2.916h-3.54A4.62 4.62 0 0 0 6.417 5.01V1.167h1.166v1.75c0 .322.261.583.584.583h2.916c.323 0 .584-.26.584-.583v-1.75h1.166v8.75ZM4.667 7a.583.583 0 0 0-.584.583v1.509l-1.066 1.066a.583.583 0 0 0 .825.825l1.237-1.237c.11-.11.171-.258.171-.413v-1.75A.583.583 0 0 0 4.667 7Z"
})));
SvgActivityClock.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivityClock);
export default ForwardRef;